import { useState, useCallback, ChangeEvent } from 'react';

interface UseInputOptions {
  onlyNumber?: boolean;
  onlyInt?: boolean;
  min?: number;
  max?: number;
}

export const useInput = (initialValue: string = '', options: UseInputOptions = {}) => {
  const [value, setValue] = useState<string>(initialValue);

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;

      // 如果设置了只能输入数字
      if (options.onlyNumber) {
        // 如果设置了只能输入整数，则不允许小数点
        if (options.onlyInt) {
          if (!/^\d*$/.test(newValue)) {
            return;
          }
        } else {
          // 允许小数点，但不允许其他非数字字符
          if (!/^\d*\.?\d*$/.test(newValue)) {
            return;
          }
        }
      }

      // 检查最小值和最大值限制
      if (newValue !== '') {
        const numValue = Number(newValue);
        if (options.min !== undefined && numValue < options.min) {
          return;
        }
        if (options.max !== undefined && numValue > options.max) {
          return;
        }
      }

      setValue(newValue);
    },
    [options],
  );

  return {
    value,
    setValue,
    onChange,
  };
};
